import { RMWCProvider as DefaultRMWCProvider } from "@rmwc/provider";
import * as React from "react";
export var RMWCProvider = function(props) {
    return /*#__PURE__*/ React.createElement(DefaultRMWCProvider, {
        icon: {
            basename: "google-material-icons"
        }
    }, props.children);
};
